import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {useMultiStyleConfig, VStack, Text} from '@chakra-ui/react'
import StoreBenefitCard from './store-benefit-card'
import {BenefitDeliveryIcon, WarrantyReturnIcon, CareShieldIcon} from '../icons'
import {delivery, returns, garanzia} from '../benefits/benefit-labels'

const OnlyAtStore = () => {
    const styles = useMultiStyleConfig('OnlyAtStore')
    const intl = useIntl()
    const garanziaUrlLink = Object.prototype.hasOwnProperty.call(
        intl.messages,
        garanzia?.urlLink?.id,
    )
        ? intl.formatMessage(garanzia?.urlLink)
        : ''

    return (
        <VStack {...styles.container}>
            <Text {...styles.title}>
                <FormattedMessage
                    id="only_at_store.section.title"
                    defaultMessage="Only at the De'Longhi store"
                />
            </Text>
            <VStack {...styles.benefitStack}>
                <StoreBenefitCard
                    icon={<BenefitDeliveryIcon {...styles.icon} />}
                    benefitTitle={<FormattedMessage {...delivery.benefitText} />}
                    benefitSubtitle={<FormattedMessage {...delivery.modalSubtitle} />}
                    infoPopoverTitle={intl.formatMessage(delivery?.infoPopover?.title)}
                    infoPopoverDescription={intl.formatMessage(delivery?.infoPopover?.description)}
                />

                <StoreBenefitCard
                    icon={<WarrantyReturnIcon {...styles.icon} />}
                    benefitTitle={<FormattedMessage {...returns.benefitText} />}
                    benefitSubtitle={<FormattedMessage {...returns.modalSubtitle} />}
                    infoPopoverTitle={intl.formatMessage(returns?.infoPopover?.title)}
                    infoPopoverDescription={intl.formatMessage(returns?.infoPopover?.description)}
                />

                <StoreBenefitCard
                    icon={<CareShieldIcon {...styles.icon} />}
                    benefitTitle={<FormattedMessage {...garanzia.benefitText} />}
                    benefitSubtitle={<FormattedMessage {...garanzia.modalSubtitle} />}
                    infoPopoverTitle={intl.formatMessage(garanzia?.infoPopover?.title)}
                    infoPopoverDescription={intl.formatMessage(garanzia?.infoPopover?.description)}
                    urlLink={garanziaUrlLink}
                    urlLinkId={garanzia?.urlLink?.id}
                />
            </VStack>
        </VStack>
    )
}

export default OnlyAtStore
